module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/hero-30e4b8d6afd27e110aa01b5861149f8e.png";